import Link from "next/link"
import { Button } from "@/components/ui/button"
import { ArrowRight, Phone } from "lucide-react"

export function CTASectionModern() {
  return (
    <section className="py-24 bg-gradient-to-br from-primary to-primary/80">
      <div className="container mx-auto px-4 md:px-6">
        <div className="mx-auto max-w-4xl text-center text-primary-foreground">
          <h2 className="text-4xl font-bold tracking-tight mb-6 lg:text-5xl">
            Ready to Start Your Project?
          </h2>
          <p className="text-xl mb-10 text-primary-foreground/90">
            Let's discuss how we can help you build the infrastructure your business needs.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button asChild size="lg" variant="secondary" className="text-lg px-8">
              <Link href="/contact">
                Get a Free Quote
                <ArrowRight className="ml-2 h-5 w-5" />
              </Link>
            </Button>
            <Button asChild size="lg" variant="outline" className="text-lg px-8 bg-transparent border-2 border-primary-foreground text-primary-foreground hover:bg-primary-foreground hover:text-primary">
              <Link href="tel:+17349996962">
                <Phone className="mr-2 h-5 w-5" />
                Call Us Now
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>
  )
}
